import React, { FC } from 'react';
import ScrollableAnchor from 'react-scrollable-anchor';
import Container from '../../container';
import Title from '../../title';
import { Grid } from '../../UIKit/system';
import { IconInfoCard } from '../../icon-info-card';

interface ProductDownloadsSectionProps {
  downloads: {
    _uid: string;
    component: 'downloadItem' | 'downloadLink';
    title: string;
    description: string;
    richDescription?: Record<string, any>;
    file?: { filename: string };
    icon?: { filename: string };
    ctaButtonText?: string;
    primaryButton?: boolean;
    gated?: boolean;
  }[];
}

export const ProductDownloadsSection: FC<ProductDownloadsSectionProps> = (
  props
) => {
  const { downloads } = props;

  return (
    <ScrollableAnchor id="downloads">
      <Container large py={[48, 96]}>
        <Grid
          gridAutoFlow={['row', 'row', 'column']}
          gridGap={[30, 30, 99]}
          gridTemplateColumns={['auto', 'auto', 'auto 1fr']}
        >
          <Grid width={['auto', 180]} alignContent="start">
            <Title as="h2" fontSizeSmall>
              Downloads
            </Title>
          </Grid>
          <Grid gridGap={16}>
            {downloads.map((download) => {
              if (download.component !== 'downloadItem' || !download.file) {
                return null;
              }

              return (
                <IconInfoCard
                  key={download._uid}
                  image={download.icon}
                  title={download.title}
                  text={download.richDescription || download.description}
                  link={download.file.filename}
                  linkText={download.ctaButtonText || 'Download'}
                  linkPrimary={download.primaryButton}
                  gated={download.gated ?? true}
                  isDownload
                />
              );
            })}
          </Grid>
        </Grid>
      </Container>
    </ScrollableAnchor>
  );
};
